import { render } from "./PassTransparencyDataTable.vue?vue&type=template&id=2fcda17e"
import script from "./PassTransparencyDataTable.vue?vue&type=script&lang=js"
export * from "./PassTransparencyDataTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__